var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#913CF0",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9459 8.62169L11.5926 16.6834L9.37592 14.315C8.96759 13.93 8.32592 13.9067 7.85925 14.2334C7.40425 14.5717 7.27592 15.1667 7.55592 15.645L10.1809 19.915C10.4376 20.3117 10.8809 20.5567 11.3826 20.5567C11.8609 20.5567 12.3159 20.3117 12.5726 19.915C12.9926 19.3667 21.0076 9.81169 21.0076 9.81169C22.0576 8.73836 20.7859 7.79336 19.9459 8.61002V8.62169Z",
    fill: "#5E42FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9459 8.62169L11.5926 16.6834L9.37592 14.315C8.96759 13.93 8.32592 13.9067 7.85925 14.2334C7.40425 14.5717 7.27592 15.1667 7.55592 15.645L10.1809 19.915C10.4376 20.3117 10.8809 20.5567 11.3826 20.5567C11.8609 20.5567 12.3159 20.3117 12.5726 19.915C12.9926 19.3667 21.0076 9.81169 21.0076 9.81169C22.0576 8.73836 20.7859 7.79336 19.9459 8.61002V8.62169Z",
    fill: "url(#paint0_linear_2141_11992)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2141_11992",
    x1: 18.8579,
    y1: 4.3499,
    x2: 10.6183,
    y2: 25.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/Check icon.cd694490382db89591f9fbca68fdfcdf.svg";
export { ForwardRef as ReactComponent };